module.exports = __webpack_public_path__ + "media/images/client/RentSearchApplication/back-0981accea1db4fc59d4558b7255f1d6b.svg";